import React from "react";

const PaxFilter = ({ options, selected, setSelected }) => {
    return (
        <div className='py-2 px-3 f12-400' style={{ borderRadius: '6rem', boxShadow: '0px 5px 10px rgba(0, 0, 0, 0.1)', backgroundColor:'#fff', width:'fit-content' }}>
            Pax: {options.map(ele => <span key={ele} className='pl-4' style={selected === ele ? { fontWeight: "bold", cursor:"pointer" } : {cursor:"pointer"}}
                onClick={() => ele === selected ? setSelected(null) : setSelected(ele)}>{ele}</span>)}
        </div>
    );
};

export default PaxFilter;
